export class Channel{
    public ID :string;
    public UserID :string;
    public SubDomain :string;
    public ClientIDGuid :string;
    public ClientSecretGuid :string;
    public LoginID :string | null;
    public Password :string | null;
    
    constructor(){
        this.ID = "00000000-0000-0000-0000-000000000000";
        this.UserID = "00000000-0000-0000-0000-000000000000";
        this.SubDomain = "";
        this.ClientIDGuid = "";
        this.ClientSecretGuid = "";
        this.LoginID = null;
        this.Password = null;
    }
}
